
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 50 50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"25","cy":"30","r":"18","fill":"#D1D6E0"}}),_c('circle',{attrs:{"cx":"25","cy":"24","r":"17.188","fill":"#fff"}}),_c('path',{attrs:{"d":"M11.063 43.332l1.509-2.019C7.582 37.415 4.589 31.451 4.589 25c0-6.497 2.97-12.46 7.96-16.313L11.04 6.668C5.425 11.008 2.083 17.714 2.083 25c.047 7.263 3.388 13.97 8.98 18.332zm26.43-34.645l1.509-2.019c5.615 4.34 8.957 11.046 8.957 18.332 0 7.263-3.342 13.97-8.957 18.332l-1.508-2.019c4.989-3.898 7.982-9.862 7.982-16.313-.023-6.497-2.993-12.438-7.982-16.313zm5.616 16.29c0 10.048-8.098 18.216-18.076 18.216S6.956 35.047 6.956 24.977c0-10.07 8.099-18.216 18.077-18.216 9.978.023 18.076 8.168 18.076 18.216zm-1.74 0c0-9.073-7.31-16.429-16.336-16.429-9.027 0-16.336 7.356-16.336 16.429 0 9.073 7.31 16.429 16.336 16.429s16.336-7.356 16.336-16.43zM16.424 27.9h1.949l-2.622-6.962H13.5l-2.622 6.962h1.95l.347-1.044h2.9l.349 1.044zm-1.81-5.407l.974 2.831H13.64l.975-2.831zm4.27 5.407h2.923c2.181 0 3.76-1.323 3.76-3.481s-1.579-3.48-3.76-3.48h-2.923v6.96zm1.81-1.578v-3.829h1.137c1.276 0 1.925.835 1.925 1.903 0 1.044-.719 1.926-1.925 1.926h-1.138zM30.95 27.9h1.95l-2.623-6.962h-2.25l-2.623 6.962h1.95l.347-1.044h2.9l.349 1.044zm-1.81-5.407l.974 2.831h-1.949l.975-2.831zm3.736 4.432c.696.673 1.67 1.114 3.086 1.114 1.88 0 2.9-.928 2.9-2.32 0-1.578-1.577-1.903-2.738-2.159-.765-.139-1.206-.278-1.206-.626 0-.302.232-.534.835-.534.627 0 1.37.232 1.973.72l.974-1.277c-.742-.626-1.717-.974-2.83-.974-1.787 0-2.785 1.02-2.785 2.18 0 1.648 1.6 1.95 2.761 2.182.743.163 1.184.302 1.184.72 0 .324-.372.603-.998.603a3.138 3.138 0 01-2.228-.928l-.928 1.3z","fill":"#171C26"}})])
          )
        }
      }
    